// 组件
import PersonalLeaseOrder from '../components/PersonalLeaseOrder.vue'
import EnterpriseLeasePrimaryOrder from '../components/EnterpriseLeasePrimaryOrder.vue'
import EnterpriseLeaseChildOrder from '../components/EnterpriseLeaseChildOrder.vue'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
// api
import { getLeaseOrderList, PurchaseAndSeven } from '@/api/purchaseAndSaleAPI'
// 其他
import selectOptionDict from '@/store/dict/selectOptionDict'
import moment from 'moment'
import { operateMaxShowLength } from '@/store/dict/config'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default function config() {
  // 租赁中订单列表tabs
  const c_underLeaseOrderTabsList = [
    {
      label: '个人租赁订单',
      name: 'personal',
      resourcesKey: 'under_lease_order_rent',
      components: PersonalLeaseOrder,
    }, {
      label: '企业租赁主订单',
      name: 'primary',
      resourcesKey: 'under_lease_order_ent',
      components: EnterpriseLeasePrimaryOrder,
    }, {
      label: '企业租赁子订单',
      name: 'child',
      resourcesKey: 'under_lease_order_ent_sub',
      components: EnterpriseLeaseChildOrder,
    },
  ]

  // 个人租赁订单tabs
  const c_personalTabsList = [
    {
      label: '全部',
      name: '2',
      tips: '已发车验车进入履约的订单',
    }, {
      label: '租赁中',
      name: '21',
      tips: '订单已到计租开始日并已发车',
    }, {
      label: '到期未还车',
      name: '22',
      tips: '订单过计租/免租结束日但未还车',
    },
  ]

  // 企业租赁订单tabs
  const c_enterpriseTabsList = [
    {
      label: '全部',
      name: '2',
      tips: '已发车验车进入履约的订单',
    }, {
      label: '租赁中',
      name: '21',
      tips: '订单已到计租开始日并已发车',
    }, {
      label: '到期未还车',
      name: '22',
      tips: '订单过计租/免租结束日但未还车',
    },
  ]

  // 企业主订单模版数据
  const c_primaryOrderConfigData = {
    formData: {
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '订单ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
        }, {
          el: 'select',
          itemConfig: {
            label: '客户名称',
            prop: 'customerId',
          },
          elConfig: {
            filterable: true,
            remote: true,
            clearable: true,
            remoteMethod: this.customerRemoteMethod,
            loading: false,
            jsxRender: (option) => {
              return <CustomerNameOptionItem data={option} />
            },
            options: {
              label: 'customerName',
              value: 'id',
              list: [],
            },
            placeholder: '请输入',
          },
        }, {
          el: 'date-picker',
          itemConfig: {
            label: '订单创建时间',
            prop: 'startTime',
          },
          elConfig: {
            type: 'daterange',
          },
        },
      ],
      exportData: {
        exportTemplate: 'EnterprisePrimary',
        filename: `履约中企业租赁订单列表导出${moment(new Date()).format('YYYYMMDD')}.xlsx`,
        permissionName: 'under_lease_order_ent_export',
      },
      dealWithSearch: this.dealWithSearch,
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            label: '订单ID',
            prop: 'id',
            width: 100,
          },
          render: ({ row }) => {
            if (!this.judgePermission('under_lease_order_ent_detail')) return row.id
            return <span class="a-hover-link" onClick={() => this.handleOrderDetail(row.id)}>{row.id}</span>
          },
        },
        {
          name: 'customerName',
          columnProps: {
            label: '客户名称',
            prop: 'customerName',
            width: 110,
          },
        },
        {
          name: 'createTime',
          columnProps: {
            label: '订单创建时间',
            prop: 'createTime',
            width: '180',
          },
        },
        {
          name: 'contractStartDate',
          columnProps: {
            label: '合同开始时间',
            prop: 'contractStartDate',
            width: 120,
          },
        },
        {
          name: 'contractEndDate',
          columnProps: {
            label: '合同结束时间',
            prop: 'contractEndDate',
            width: 120,
          },
        },
        {
          name: 'carTotalNum',
          columnProps: {
            label: '租赁车辆数',
            prop: 'carTotalNum',
            width: 100,

          },
        },
        {
          name: 'rentedCarNum',
          columnProps: {
            label: '已租车辆数',
            prop: 'rentedCarNum',
            width: 100,

          },
        },
        {
          name: 'returnCarNum',
          columnProps: {
            label: '订单退车数',
            prop: 'returnCarNum',
            width: 100,
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '订单状态',
            prop: 'state',
          },
          getText: ({ row }) => selectOptionDict.underLeaseOrderStateList[row.state],
        },
        {
          name: 'createUserName',
          columnProps: {
            label: '创建人',
            prop: 'createUserName',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const result = []
            if (this.judgePermission('under_lease_order_ent_add_car')) {
              result.push({ name: 'addRentOrder', label: '新增租赁车辆', action: () => this.handleAddCarClick(row) })
            }
            if (this.judgePermission('under_lease_order_ent_close')) {
              result.push({ name: 'close', label: '关闭订单', action: () => this.getVoidComplete(row) })
            }
            return result
          },
        },
      ],
      apiFn: getLeaseOrderList,
    },
  }

  // 企业主子订单模版数据
  const c_childOrderConfigData = {
    formData: {
      list: [
        {
          el: 'select',
          itemConfig: {
            label: '车牌号',
            prop: 'carId',
          },
          elConfig: {
            remoteMethod: this.carRemoteMethod,
            filterable: true,
            remote: true,
            clearable: true,
            placeholder: '请输入',
            options: { // 下拉数据
              label: 'plateNo',
              value: 'id',
              list: [],
            },
          },
        }, {
          el: 'select',
          itemConfig: {
            label: '客户名称',
            prop: 'customerId',
          },
          elConfig: {
            jsxRender: (option) => {
              return <CustomerNameOptionItem data={option} />
            },
            filterable: true,
            clearable: true,
            remote: true,
            remoteMethod: this.customerRemoteMethod,
            options: { // 下拉数据
              label: 'customerName',
              value: 'id',
              list: [],
            },
            placeholder: '请输入',
          },
        }, {
          el: 'input',
          itemConfig: {
            label: '子订单ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            placeholder: '请输入子订单ID',
            clearable: true,
          },
        }, {
          el: 'input',
          itemConfig: {
            label: '主订单ID',
            prop: 'entRentOrderId',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            placeholder: '请输入主订单ID',
            clearable: true,
          },
        }, {
          itemConfig: {
            prop: 'brandSeriesModel',
          },
          elConfig: {
            showModel: true,
            filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
          },
          render: 'CarBrandSeriesModel',
        }, {
          el: 'select',
          itemConfig: {
            label: '运营城市',
            prop: 'adcode',
          },
          elConfig: {
            clearable: true,
            filterable: true,
            reserveKeyword: true,
            defaultFirstOption: true,
            placeholder: '请选择',
            options: {
              label: 'city',
              value: 'adcode',
              list: [],
            },
          },
        }, {
          el: 'date-picker',
          itemConfig: {
            label: '发车验车时间',
            prop: 'TheCarExTime',
          },
          elConfig: {
            clearable: true,
          },
        }, {
          el: 'date-picker',
          itemConfig: {
            label: '订单创建时间',
            prop: 'startTime',
          },
          elConfig: {
            clearable: true,
          },
        }, {
          el: 'date-picker',
          itemConfig: {
            label: '计租开始日',
            prop: 'rentStartTime',
          },
          elConfig: {
            clearable: true,
          },
        }, {
          el: 'date-picker',
          itemConfig: {
            label: '计租结束日',
            prop: 'rentFinIsh',
          },
          elConfig: {
            clearable: true,
          },
        },
      ],
      exportData: {
        exportTemplate: 'EnterpriseChild',
        filename: `履约中企业租赁子订单列表导出${moment(new Date()).format('YYYYMMDD')}.xlsx`,
        permissionName: 'under_lease_order_ent_sub_export',
      },
      dealWithSearch: this.dealWithSearch,
      customizeReset: () => {
        this.$refs.baseListManagement.setItemData({
          elConfigKey: 'value',
          key: 'brandSeriesModel',
          data: {},
        })
      },
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '子订单ID',
            width: '120',
          },
          render: ({ row }) => {
            if (!this.judgePermission('under_lease_order_ent_sub_detail')) return row.id
            return <span class="a-hover-link" onClick={() => this.toOrderDetailPage({ id: row.id, deptId: row.deptId })}>{row.id}</span>
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: '100',
          },
        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
          },
        },
        {
          name: 'modelName',
          columnProps: {
            prop: 'modelName',
            label: '车型',
            width: 160,
          },
        },
        {
          name: 'city',
          columnProps: {
            prop: 'city',
            label: '运营城市',
          },
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '客户名称',
            width: 110,
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '订单创建时间',
            width: '160',
          },
        },
        {
          name: 'outStockTime',
          columnProps: {
            prop: 'outStockTime',
            label: '发车验车时间',
            width: '160',
          },
        },
        {
          name: 'rentAmount',
          columnProps: {
            prop: 'rentAmount',
            label: '每期租金',
            width: '100',
          },
        },
        {
          name: 'deposit',
          columnProps: {
            label: '总押金/已收',
            width: '120',
            align: 'left',
            formatter: (row) => `${row.deposit === null ? '0.00' : row.deposit}/${row.receivedDeposit}`,
          },
        },
        {
          name: 'startDate',
          columnProps: {
            prop: 'startDate',
            label: '计租开始日',
            width: '120',
          },
        },
        {
          name: 'endDate',
          columnProps: {
            prop: 'endDate',
            label: '计租结束日',
            width: '120',
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '子订单状态',
            formatter: (row) => selectOptionDict.leaseOrderState[row.state],
            width: '120',
          },
        },
        {
          name: 'entRentOrderId',
          columnProps: {
            label: '企业租赁订单ID',
            prop: 'entRentOrderId',
            width: '120',
          },
        },
        {
          name: 'createUser',
          columnProps: {
            prop: 'createUser',
            width: '110',
            label: '订单创建人',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          // 待履约
          //   --订单待确认 0
          //   --发车待验车 1500
          //   --履约中 2500
          // 退车核算
          //   --退车待验车 3500
          //   --订单待核算 4500
          //   --已关闭 5500
          getOperateList: ({ row }) => {
            const btnArr = []
            this.judgePermission('under_lease_order_ent_sub_terminate_agreement') && btnArr.push({
              name: 'closeRentOrders_name',
              label: '退车',
              action: () => {
                this.toReturnCarPage(row)
              },
            })
            return btnArr
          },
        },
      ],
      apiFn: PurchaseAndSeven,
    },
  }
  return {
    // 企业主子订单模版数据
    c_childOrderConfigData,
    // 企业主订单模版数据
    c_primaryOrderConfigData,
    // 租赁中订单列表tabs
    c_underLeaseOrderTabsList,
    // 个人租赁订单tabs
    c_personalTabsList,
    // 企业租赁订单tabs
    c_enterpriseTabsList,
  }
}
